<span class="banner__icon">{{icon}}</span>

<span class="banner__text">{{message}}</span>

<ng-container *ngIf="buttons">
  <button class="button banner__button" *ngFor="let button of buttons" (click)="button.action()" type="button">
    <img [src]="button.icon" class="button__icon">
    <span class="button__text"> {{button.text}} </span>
  </button>
</ng-container>
